<template>
  <section>
    <div id="production-video" class="pd70 wbg">
      <UiBg src="/static/image/video_bg_bw.jpg" />
      <div class="wrapper">
        <UiAnim tag="h2" class="block_title">Видео производства</UiAnim>

        <UiAnim
          tag="button"
          class="video_button"
          @click="showVideo()"
        ></UiAnim>
      </div>
    </div>
  </section>
  <ModalMVideo src="production" v-if="video" @closed="video = false" />
</template>

<script setup>
const { isModal, mVideo } = useModal();
const video = ref();
const showVideo = () => {
  if (!isModal) return mVideo("production");
  video.value = true;
};
</script>
